module.exports = __webpack_public_path__ + "media/images/basic_logos/user-8826fadf3b49b7a39c219f8e366f5753.svg";